export default __webpack_public_path__ + "static/media/3_2_hl.f8c58b39.png";